import { createFileRoute } from "@tanstack/react-router";
import DataDeletionPage from "@/features/public/pages/data-deletion";

export const Route = createFileRoute("/(public)/_public/data-deletion")({
  component: DataDeletionPage,
});
